import storage from "store";
import {abChinaLogin} from '@/api/login'
import {ACCESS_TOKEN} from '@/store/mutation-types'

export const myMixins = {
  data() {
    return {}
  },
  created() {
    const token = storage.get(ACCESS_TOKEN)
    if (!token) {
      this.login()
    }
  },
  methods: {
    login() {
      if (this.$route.query.code) {
        const data = {
          code: this.$route.query.code,
          redirectUri: this.delParam('code')
        }
        abChinaLogin(data).then(res => {
          if (res.code === 10000) {
            storage.set(ACCESS_TOKEN, res.result.jwtToken)
            location.replace(data.redirectUri)
          }
        })
      } else {
        const params = {
          "client_id": "cf63ed13-52ec-4acc-b6cb-56cd1f8ae144",
          "redirect_uri": window.location.href,
          "state": "123456",
          "scope": "openid",
          "response_type": "code"
        }
        window.top.location.href = 'https://www.abchina.com/luascript/oauthLogin/' + JSON.stringify(params).replace(/\\"/g, "\"")
      }
    },
    // 删除url中某个参数,并跳转
    delParam(paramKey) {
      let url = window.location.href;    //页面url
      let urlParam = window.location.search.substr(1);   //页面参数
      let beforeUrl = url.substr(0, url.indexOf("?"));   //页面主地址（参数之前地址）
      let nextUrl = "";

      let arr = new Array();
      if (urlParam != "") {
        let urlParamArr = urlParam.split("&"); //将参数按照&符分成数组
        for (let i = 0; i < urlParamArr.length; i++) {
          let paramArr = urlParamArr[i].split("="); //将参数键，值拆开
          //如果键雨要删除的不一致，则加入到参数中
          if (paramArr[0] != paramKey) {
            arr.push(urlParamArr[i]);
          }
        }
      }
      if (arr.length > 0) {
        nextUrl = "?" + arr.join("&");
      }
      url = beforeUrl + nextUrl;
      return url;
    }
  }
}
